import { ExportOrganizationDataResponseSchema } from './export-organization-data.schema';
/**
 * Export Organization Data Endpoint Contract
 * Export the organization's domain data (allowlisted, see ADR 0038) as a ZIP of JSON files
 */ export const exportOrganizationDataContract = {
    method: 'GET',
    path: '/api/v2/data-export/zip',
    description: "Export the organization's domain data (allowlisted, see ADR 0038) as a ZIP of JSON files",
    responseSchema: ExportOrganizationDataResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - insufficient permissions',
            404: 'Not found - the tenant has no organization document',
            500: 'Internal server error - failed to generate export'
        }
    }
};

//# sourceMappingURL=export-organization-data.contract.js.map